import React from "react";

import HomeUI from "../../../ui/homeUI/_index";

const ReportRanking = () => {
  return (
    <>
      <HomeUI />
    </>
  )
}

export default ReportRanking